import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

const TabPane = ({ children }) => {
  return <div>{children}</div>
}

TabPane.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
}

export default compose(pure)(TabPane)
